import { useEffect, useRef } from "react";

// Re-ejecuta fn cada `ms` mientras la pestaña está visible, y al volver a ella.
export function useLive(fn, ms = 5000, enabled = true) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => { if (document.visibilityState === "visible" && navigator.onLine !== false) Promise.resolve(ref.current()).catch(() => {}); };
    const t = setInterval(tick, ms);
    document.addEventListener("visibilitychange", tick);
    window.addEventListener("focus", tick);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", tick); window.removeEventListener("focus", tick); };
  }, [ms, enabled]);
}
